<template>
    <div class="login_container">
      <div class="login_box">
         <div class="head_img">
            <img src="../assets/logo.png" alt="">
         </div>
         <el-form ref="loginFormRef" :model="login_form" :rules="myrules" label-width="0px" class="login_form">
            <!--用户名-->
            <el-form-item prop="username">
               <el-input v-model="login_form.username" prefix-icon="el-icon-user"></el-input>
            </el-form-item>
            <!--密码-->
            <el-form-item prop="password">
               <el-input type="password" v-model="login_form.password" prefix-icon="el-icon-lock"></el-input>
            </el-form-item>
            <!--按钮-->
            <el-form-item  class="btn">
               <el-button type="primary" @click="login">登录</el-button>
               <el-button type="info" @click="resetloginForm">重置</el-button>
            </el-form-item>
         </el-form>
      </div>
    </div>
</template>
<script>
export default {
   data() {
      return {
         login_form:{
            username:'',
            password:''
         },
         myrules:{
            username:[
            {required:true,message:'请输入用户名',trigger:'blur'},
            {min:3,max:20,message:'长度在 3 到 20 个字符',trigger:'blur'}   
            ],
            password:[
               {required:true,message:'请输入密码',trigger:'blur'},
               {min:6,max:15,message:'长度在 6 到 15 个字符',trigger:'blur'}
            ]
         }
      }
   },
   methods:{
      //点击重置按钮
      resetloginForm(){
         //console.log(this);
         this.$refs.loginFormRef.resetFields();
      },
      login(){
         this.$refs.loginFormRef.validate(async valid=>{
         if(!valid) return;
           const formData = this.login_form; // 获取表单数据
           var username = formData.username;
           var password = formData.password;
           const {data:res} = await this.$http.get('Login/adminYz?username='+username+'&password='+password);

           if(res.code!==200) return this.$message.error('登录失败');
           this.$message.success('登录成功');
           window.sessionStorage.setItem('token',res.data.jwt);
           window.sessionStorage.setItem('ids',res.data.id);
           window.sessionStorage.setItem('user_name',res.data.user_name);         
           this.$router.push('/home');
         });
      }
   }
}
</script>

<style lang="less" scoped>
.login_container{
   background-color: #2b4b6b;
   height: 100%;
}
.login_box{
   width: 450px;
   height: 300px;
   background-color: #fff;
   border-radius: 3px;
   position:absolute;
   left: 50%;
   top: 50%;
   transform: translate(-50%,-50%);

   .head_img{
      border: 1px solid #eee;
      border-radius: 50%;
      height: 130px;
      width: 130px;
      padding: 10px;
      box-shadow: 0 0 10px #ddd;
      position:absolute;
      left: 50%;
      transform:translate(-50%,-50%);
      background-color: #fff;
      img{
         width: 100%;
         height: 100%;
         border-radius: 50%;
         background-color: #eee;
      }
   }
}
.login_form{
   position: absolute;
   bottom: 0;
   width: 100%;
   padding: 0 20px;
   box-sizing: border-box;
}
.btn{
   display: flex;
   justify-content: flex-end;
}
</style>
